import * as React from "react";
import { QueryString } from "@grandvisionhq/utils";
import { normaliseQueryParams } from "../../utils/v3/hooks/utils/normalise-params.js";
const useClientSideRouter = ({
  basePath,
  initialRoute = "",
  initialQueryParams = {},
  onRouteChange,
  routerId
}) => {
  const [currentQueryParams, setCurrentQueryParams] = React.useState(
    normaliseQueryParams(initialQueryParams)
  );
  const [currentRoute, setCurrentRoute] = React.useState(initialRoute);
  const onRedirect = React.useCallback(
    (event) => {
      const { state } = event;
      const { as = "" } = state ?? {};
      const [pathname, queryParams] = as.split("?");
      const routePath = pathname.replace(basePath, "");
      const [_, route] = routePath.split("/");
      setCurrentQueryParams(
        normaliseQueryParams(QueryString.parse(queryParams ?? "") ?? {})
      );
      setCurrentRoute(route || "");
      onRouteChange && onRouteChange(route || "");
    },
    [basePath, onRouteChange]
  );
  const onPopState = React.useCallback(
    (event) => {
      if (event?.state?.as === void 0) {
        location.reload();
      } else {
        onRedirect(event);
      }
    },
    [onRedirect]
  );
  const goTo = React.useCallback(
    (redirectPath) => {
      window.history.pushState({ as: redirectPath }, "", redirectPath);
      onRedirect({ state: { as: redirectPath } });
    },
    [onRedirect]
  );
  const updateCurrentQueryParams = React.useCallback((href) => {
    const search = (href ?? window.location.href).split("?")[1] ?? "";
    const currentQueryParams2 = normaliseQueryParams(
      QueryString.parse(search)
    );
    setCurrentQueryParams(currentQueryParams2);
  }, []);
  React.useEffect(() => {
    const original = window.history.replaceState;
    const revocable = Proxy.revocable(window.history.replaceState, {
      apply: (target, thisArgument, args) => {
        const result = Reflect.apply(target, thisArgument, args);
        const url = args[2];
        updateCurrentQueryParams(url instanceof URL ? url.href : url);
        return result;
      }
    });
    window.history.replaceState = revocable.proxy;
    return () => {
      window.history.replaceState = original;
      revocable.revoke();
    };
  }, [updateCurrentQueryParams]);
  React.useEffect(() => {
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, [onRedirect]);
  return React.useMemo(
    () => [{ goTo }, { basePath, currentRoute, queryParams: currentQueryParams, routerId }],
    [goTo, basePath, currentRoute, currentQueryParams, routerId]
  );
};
export {
  useClientSideRouter as default
};
//# sourceMappingURL=use-client-side-router.js.map
